<template>
  <div
    :style="{
      'background-image':
        'linear-gradient(rgba(0, 0, 0, 0.833) 0%, rgba(0, 0, 0, 0.714) 100%), url(' +
        this.movie.Image +
        ')',
    }"
    class="buy"
  >
    <div class="buy-header">
      <div v-if="this.user.sessionEndAt" class="timer">
        <div class="timer-label">Осталось</div>

        <div class="timer-time">
          <Timer
            :endtime="this.user.sessionEndAt"
            starttime="Sep 4, 2018 18:00:00"
            trans='{
           "day":"Дней",
           "hours":"Часов",
           "minutes":"Минут",
           "seconds":"Секунд",
           "expired":"Event has been expired.",
           "running":"До конца сессии",
           "upcoming":"С начала сессии",
           "status": {
              "expired":"Истек",
              "running":"Запущен",
              "upcoming":"Future"
             }}'
          ></Timer>
        </div>
      </div>
      <div class="contact" v-if="theatre.SupportPhone">
        <div class="contact-label">Служба поддержки</div>
        <div class="contact-number">{{ theatre.SupportPhone }}</div>
      </div>
      <div class="button-back" @click="goBack">
        <span class="btn-icon fa fa-long-arrow-left"></span>
      </div>
    </div>
    <div class="buy-body" :style="!isScroll && 'height: calc(100vh - 65px);'">
      <div class="buy-body-wrapper">
        <div
          v-if="session.DateTime"
          :style="{
            'background-image':
              'linear-gradient(to bottom, #000000b3 0%, #000000b3 100%), url(' +
              this.movie.Image +
              ')',
          }"
          class="buy-session-wrapper"
        >
          <div class="buy-session-title" v-if="session.DateTime">
            {{ session.DateTime | moment('dddd, D MMMM в H:mm') }}
          </div>
          <div class="buy-session-footer">
            <div class="buy-session-tags">
              <div class="tag" v-if="session.Format">
                {{ session.Format.Name }}
              </div>
              <div class="tag">{{ `${movie.Age}+` }}</div>
            </div>
            <div class="buy-session-name">{{ session.MovieName }}</div>
          </div>
        </div>
        <div class="cart-wrapper">
          <div class="cart-wrapper-inner">
            <div
              class="cart-scrollable"
              :style="{
                'max-height':
                  (customer.accounts &&
                    // setting.isBonusAvailable &&
                    user.gender &&
                    user.birthday &&
                    user.name &&
                    user.phone) ||
                  theatre.Donation.IsActive
                    ? 'none'
                    : '25vh',
              }"
            >
              <div class="theatre-wrapper">
                <div class="label">Площадка</div>
                <div class="name" v-if="session.Hall">
                  {{ theatre.Name }}, {{ session.Hall.Name }}
                </div>
                <div class="address">{{ theatre.Address }}</div>
              </div>
              <div class="buy-cart cart-items">
                <div class="cart-group cart-ticket">
                  <div class="label">Билеты</div>
                  <div class="list">
                    <div
                      :key="index"
                      class="item"
                      v-for="(ticket, index) in cart.tickets"
                    >
                      <span class="position" v-if="!session.NoSeats"
                        >{{ ticket.row }} ряд {{ ticket.number }} место</span
                      >
                      <span class="position" v-else>{{ ticket.Name }}</span>
                      <span class="dots"></span>
                      <span class="price" v-if="ticket.price"
                        >{{ ticket.price }} {{ setting.currency }}</span
                      >
                      <span class="price" v-else>Бесплатно</span>
                    </div>

                    <div
                      :key="accountId"
                      v-for="accountId in customer.accountsList"
                      v-if="customer.accounts"
                    >
                      <div
                        class="item item_bonuses"
                        v-if="
                          customer.accounts[accountId].selected &&
                          customer.accounts[accountId].discount.tickets !== 0
                        "
                      >
                        <span class="position">{{
                          customer.accounts[accountId].type.name
                        }}</span>
                        <span class="dots"></span>
                        <span class="price"
                          >{{ customer.accounts[accountId].discount.tickets }}
                          {{ setting.currency }}</span
                        >
                      </div>
                    </div>

                    <div class="item item_result">
                      <span class="position">Промежуточный итог</span>
                      <span class="dots"></span>
                      <span class="price"
                        >{{ cart.ticketSum - cart.spentBonuses.tickets }}
                        {{ setting.currency }}</span
                      >
                    </div>
                    <div
                      class="item item_result item_bonuses"
                      v-if="!!promoData"
                    >
                      <span class="position">{{ promoData.promoName }}</span>
                      <span class="dots"></span>
                      <span class="price"
                        >{{ cart.ticketSum - cart.spentBonuses.tickets }}
                        {{ setting.currency }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="cart-group cart-bar" v-if="cart.bar.length">
                  <div class="label">Бар</div>
                  <div class="list">
                    <div
                      :key="index"
                      class="item"
                      v-for="(item, index) in cart.bar"
                    >
                      <span class="position"
                        >{{ item.Name }} {{ item.size }} ({{
                          item.count
                        }}шт.)</span
                      >
                      <span class="dots"></span>
                      <span class="price"
                        >{{ getTotalPrice(item.Price, item.count) }}
                        {{ setting.currency }}</span
                      >
                    </div>

                    <div
                      :key="accountId"
                      v-for="accountId in customer.accountsList"
                      v-if="customer.accounts"
                    >
                      <div
                        class="item item_bonuses"
                        v-if="
                          customer.accounts[accountId].selected &&
                          customer.accounts[accountId].discount.bar !== 0
                        "
                      >
                        <span class="position">{{
                          customer.accounts[accountId].type.name
                        }}</span>
                        <span class="dots"></span>
                        <span class="price"
                          >{{ customer.accounts[accountId].discount.bar }}
                          {{ setting.currency }}</span
                        >
                      </div>
                    </div>

                    <div class="item item_result">
                      <span class="position">Промежуточный итог</span>
                      <span class="dots"></span>
                      <span class="price"
                        >{{ cart.barSum - cart.spentBonuses.bar }}
                        {{ setting.currency }}</span
                      >
                    </div>
                  </div>
                </div>

                <div
                  class="cart-group cart-bar"
                  v-if="cart.donations && user.paymentType !== 'PushkinFilm'"
                >
                  <div class="label">Поддержать кинотеатр</div>
                  <div class="list">
                    <div class="item">
                      <span class="dots"></span>
                      <span class="price"
                        >{{ cart.donations }} {{ setting.currency }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cart-total">
            <div class="cart-total-label label">Итого:</div>
            <div class="cart-total-price">
              {{ amountDue }} {{ setting.currency }}
            </div>
          </div>
        </div>
      </div>
      <div class="payment-wrapper" ref="heightBody">
        <div class="payer-contact">
          <form class="form">
            <div class="step-box">
              <div class="step-box-label">1. Куда прислать заказ</div>
              <div class="step-box-inputs">
                <div class="input-wrapper">
                  <input
                    :class="{ hasError: this.emailError }"
                    :value="email"
                    @input="updateEmail"
                    placeholder="Email"
                    type="email"
                  />
                  <small class="input-error" v-if="this.emailError">{{
                    this.emailError
                  }}</small>
                </div>

                <div class="input-wrapper">
                  <input
                    :value="user.phone"
                    @input="updateUserPhone"
                    placeholder="Телефон"
                    type="text"
                    v-mask="
                      setting.currency === '₽'
                        ? '+7 (###) ###-##-##'
                        : '+375 (##) ###-##-##'
                    "
                  />
                  <small class="input-error" v-if="this.phoneError">{{
                    this.phoneError
                  }}</small>
                  <span class="input-phone-desc" v-else
                    >Телефон необходим для связи в экстренных случаях</span
                  >
                </div>
                <div
                  v-if="!this.movie.IsEventRegister"
                  class="input-wrapper checkbox-wrapper"
                >
                  <input
                    :value="user.subscription"
                    @change="updateSubscription"
                    class="hidden-check"
                    id="subscription"
                    style="display: none"
                    type="checkbox"
                  />
                  <label
                    class="check"
                    for="subscription"
                    style="margin-inline: 0"
                  >
                    <svg height="18px" viewBox="0 0 18 18" width="18px">
                      <path
                        d="M1,3.5 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,4.5"
                      ></path>
                      <polyline points="1 9 7 14 15 4"></polyline>
                    </svg>
                    <span>
                      Я хочу еженедельно узнавать о новостях и новых событиях
                    </span>
                  </label>
                </div>

              </div>
              <template v-if="this.movie.IsEventRegister">
                <div class="step-box-inputs">
                  <div class="input-wrapper">
                    <input
                      :class="{ hasError: this.fullNameError }"
                      :value="fullName"
                      @input="updateFullName"
                      placeholder="ФИО"
                      type="text"
                    />
                    <small class="input-error" v-if="this.fullNameError">{{
                      this.fullNameError
                    }}</small>
                  </div>
                  <div class="input-wrapper">
                    <input
                      :class="{ hasError: this.countryError }"
                      :value="country"
                      @input="updateCountry"
                      placeholder="Страна"
                      type="text"
                    />
                    <small class="input-error" v-if="this.countryError">{{
                      this.countryError
                    }}</small>
                  </div>
                  <div class="input-wrapper">
                    <input
                      :class="{ hasError: this.cityError }"
                      :value="city"
                      @input="updateCity"
                      placeholder="Город"
                      type="text"
                    />
                    <small class="input-error" v-if="this.cityError">{{
                      this.cityError
                    }}</small>
                  </div>
                  <div class="input-wrapper">
                    <input
                      :class="{ hasError: this.organizationError }"
                      :value="organization"
                      @input="updateOrganization"
                      placeholder="Должность"
                      type="text"
                    />
                    <small class="input-error" v-if="this.organizationError">{{
                      this.organizationError
                    }}</small>
                  </div>
                  <div class="input-wrapper">
                    <input
                      :class="{ hasError: this.cinemaNameError }"
                      :value="cinemaName"
                      @input="updateCinemaName"
                      placeholder="Кинотеатр"
                      type="text"
                    />
                    <small class="input-error" v-if="this.cinemaNameError">{{
                      this.cinemaNameError
                    }}</small>
                  </div>
                </div>
              </template>
            </div>

            <div
              v-if="showDonationStep"
              class="step-box donation-step"
            >
              <div class="step-box-label">
                2. {{ theatre.Donation.Title || 'Поддержать кинотеатр' }}
              </div>

              <p
                v-html="
                  theatre.Donation.Description ||
                  'Мы благодарны каждому, кто поддержит кинотеатр'
                "
              ></p>
              <div class="step-box-inputs">
                <div class="variants-donation">
                  <label
                    v-for="(donationMoneySize, index) in theatre.Donation
                      .DefaultValues"
                    v-bind:key="index"
                    @click="selectDonationSizes(donationMoneySize)"
                  >
                    {{ donationMoneySize }} {{ setting.currency }}
                  </label>
                </div>
                <span class="and">или</span>
                <div class="input-wrapper">
                  <input
                    :value="cart.donations"
                    id="donations"
                    @input="onChangeInputDonationSizes"
                    placeholder="Введите сумму"
                    type="number"
                    @keypress="onlyNumber"
                  />
                </div>
              </div>
            </div>

            <div
              v-if="showPromoStep"
              class="step-box donation-step"
            >
              <div class="step-box-label">
                {{ showDonationStep ? 3 : 2 }}. Использовать промокод
              </div>

              <p
                v-html="
                  'Если у вас есть промокод на скидку, можете его использовать в поле ниже'
                "
              ></p>
              <div class="step-box-inputs">
                <div class="input-wrapper">
                  <input
                    :value="cart.promocode"
                    id="promocod"
                    @input="onChangeInputPromocode"
                    type="text"
                    placeholder="Введите промокод"
                  />
                  <span class="promo-error" v-if="promoError">
                    {{ promoError }}
                  </span>
                </div>
                <button
                  class="promo-apply"
                  :class="cart.promocode ? 'active' : ''"
                  @click="usePromocodeClick"
                  :disabled="!cart.promocode"
                >
                  Применить
                </button>
              </div>
            </div>

            <GiftCards ref="giftCards" :initialized="paymentInitialized" :step-number="giftCardsStep" />

            <div class="step-box" v-if="showPaymentMethods">
              <div class="step-box-label">
                {{ paymentMethodLabel }}
              </div>
              <div class="payment-type-list select-list">
                <div
                  class="payment-type-item-wrapper"
                  style="
                    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
                    margin-right: 44px;
                    width: 100%;
                  "
                >
                  <div
                    v-if="amountDue > 0 && isCardShow"
                    :class="{ selected: isSelectedPayment('Base') }"
                    @click="setPaymentType('Base')"
                    class="payment-type-item"
                  >
                    <div class="content">
                      <div class="name">Банковская карта</div>
                    </div>
                  </div>

                  <div
                    v-if="amountDue > 0 && isSbpEnabled"
                    @click="updateSbpIsSelected"
                    :class="{ selected: isSbpSelected }"
                    class="payment-type-item"
                  >
                    <div class="content">
                      <img :src="sbpLogo" width="16" height="20" />
                      <div class="name">СБП</div>
                    </div>
                  </div>

                  <div
                    v-if="isPushkinShow"
                    :class="{
                      selected: isSelectedPayment('PushkinFilm'),
                      'button-hover':
                        cart.tickets.length !== 1 ||
                        (session.PushkinId && !user.isAuthorized),
                    }"
                    @click="setPaymentType('PushkinFilm')"
                    class="payment-type-item"
                  >
                    <div class="content">
                      <div class="name">Пушкинская карта</div>
                    </div>
                    <div class="tooltip-payment-pushkin">
                      {{ tooltipPushkinText }}
                    </div>
                  </div>
                </div>

                <div
                  :key="index"
                  style="width: 100%"
                  v-for="(accountId, index) in customer.accountsList"
                  v-if="
                    customer.accounts &&
                    // setting.isBonusAvailable &&
                    user.gender &&
                    user.birthday &&
                    user.name &&
                    user.phone &&
                    !isSelectedPayment('PushkinFilm')
                  "
                >
                  <AccountButton :accountId="accountId" @manual-change="onManualBonuses" />
                </div>

                <div
                  class="payment-type-item"
                  v-if="
                    user.isAuthorized &&
                    customer.accounts &&
                    // setting.isBonusAvailable &&
                    (!user.gender ||
                      !user.birthday ||
                      !user.name ||
                      !user.phone)
                  "
                >
                  <div class="content">
                    <div class="name">
                      Для списания бонусов
                      <a
                        :href="linkOnSiteWithWidget + '/user/cabinet'"
                        target="_blank"
                        style="text-decoration: underline; color: #fff"
                        >заполните профиль на сайте</a
                      >
                    </div>
                  </div>
                </div>

                <div
                  class="payment-method-item-wrapper"
                  v-if="theatre.HasBonusSystem"
                >
                  <div
                    class="payment-type-item-wrapper"
                    v-if="user.isAuthorized && user.card.id"
                  >
                    <div
                      :class="{ selected: user.paymentWithBonuses }"
                      @click="setPaymentWithBonuses(false, user.card.balance)"
                      class="payment-type-item pti-bonus"
                    >
                      <div class="content">
                        <div class="name">Бонусы ПремьерЗала:</div>
                        <div class="discount-flat">
                          {{ user.card.balance }}
                          {{ setting.currency }} (Остаток:
                          {{ getLeftBonuses() }} {{ setting.currency }})
                        </div>
                      </div>
                    </div>
                    <div
                      @click="toggleBonusSlider"
                      class="change-bonus"
                      v-if="!bonusSliderShown && user.card.balance"
                    >
                      <svg1 />
                    </div>
                    <div
                      :class="{ 'bonus-picker_shown': bonusSliderShown }"
                      class="bonus-picker"
                    >
                      <vue-slider
                        :interval="1"
                        :lazy="true"
                        :max="user.maxBonuses"
                        :min="0"
                        :tooltip="'always'"
                        :tooltip-placement="'bottom'"
                        @change="applyBonuses"
                        v-model="cart.usedBonuses"
                      ></vue-slider>
                    </div>
                  </div>

                  <div
                    @click="showModalCard"
                    class="payment-type-item"
                    v-if="
                      !user.isAuthorized && !customer.accountsList.length
                      // && setting.isBonusAvailable
                    "
                  >
                    <div class="content">
                      <div class="name">
                        Зарегистрироваться или авторизоваться
                      </div>
                    </div>
                  </div>

                  <span
                    class="text-warning"
                    v-if="
                      user.centralCrmList &&
                      !user.centralCrmList.includes(this.theatre.CrmSystemId)
                    "
                  >
                    Вы находитесь в другой системе кинотеатра.
                    Зарегистрируйтесь, чтобы получать бонусы!
                  </span>
                  <div class="payment-items">
                    <div
                      @click="showModalCardRegister"
                      class="payment-type-item altRegister"
                      v-if="
                        user.centralCrmList &&
                        !user.centralCrmList.includes(this.theatre.CrmSystemId)
                      "
                    >
                      <div class="content" style="justify-content: center">
                        <div class="name">Зарегистрироваться</div>
                      </div>
                    </div>

                    <div
                      class="payment-type-item"
                      v-if="user.isAuthorized && !customer.accountsList.length"
                    >
                      <div class="content">
                        <div class="name">У вас нет бонусной карты</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="step-box" v-if="user.paymentType === 'PushkinFilm'">
              <div class="step-box-label">3. Данные Пушкинской карты</div>
              <div class="step-box-description">
                * Пожалуйста, введите ваши фамилию, имя и отчество точно так,
                как указано в паспорте.
              </div>
              <div class="step-box-inputs">
                <div class="input-wrapper">
                  <input
                    :class="{ hasError: this.userNameError }"
                    :value="user.name"
                    @input="updateUserName"
                    placeholder="Фамилия Имя Отчество"
                    type="text"
                  />
                  <small class="input-error" v-if="this.userNameError">{{
                    this.userNameError
                  }}</small>
                </div>

                <div
                  class="input-wrapper checkbox-wrapper"
                  style="flex-direction: column; align-items: start"
                >
                  <input
                    :value="userAgreenment"
                    :checked="userAgreenment"
                    @change="updateUserAgreenment"
                    class="hidden-check"
                    id="user-agreenment"
                    style="display: none"
                    type="checkbox"
                  />
                  <label
                    class="check"
                    for="user-agreenment"
                    style="margin-inline: 0"
                  >
                    <svg height="18px" viewBox="0 0 18 18" width="18px">
                      <path
                        d="M1,3.5 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,4.5"
                      ></path>
                      <polyline points="1 9 7 14 15 4"></polyline>
                    </svg>
                    <span
                      @click="showUserAgreement"
                      style="text-decoration: underline"
                    >
                      Отправляя форму я даю согласие на обработку персональных
                      данных
                    </span>
                  </label>
                  <small class="input-error" v-if="this.userAgreenmentError"
                    >Обязательно</small
                  >
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="cart-next" v-if="this.user.paymentType">
          <div class="checkout-agreement">
            <input
              :checked="user.isAgreementsAccepted"
              @change="updateAgreementsAccepted"
              class="hidden-check"
              id="isAgreementsAccepted"
              style="display: none"
              type="checkbox"
            />
            <label
              class="check"
              for="isAgreementsAccepted"
              style="margin-inline: 0"
            >
              <svg height="18px" viewBox="0 0 18 18" width="18px">
                <path
                  d="M1,3.5 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,4.5"
                ></path>
                <polyline points="1 9 7 14 15 4"></polyline>
              </svg>
              <span>
                Нажимая, вы даете согласие на
                <a
                  @click.prevent="showUserAgreement"
                  style="color: white; text-decoration: underline"
                  href="#"
                  target="_blank"
                  >обработку персональных данных</a
                >
                и соглашаетесь с
                <a
                  @click.prevent="showPrivacyPolicy"
                  style="color: white; text-decoration: underline"
                  href="#"
                  target="_blank"
                  >политикой конфиденциальности</a
                >
              </span>
            </label>
            <small
              class="input-error"
              v-if="this.isAgreementsAcceptedError"
              >{{ this.isAgreementsAcceptedError }}</small
            >
          </div>
          <button @click="makeOrder" class="basket-btn" :disabled="paymentBusy">
            <span class="btn-icon"></span>
            <span class="btn-label">{{ submitBtnText }}</span>
          </button>
          <!-- <div class="agreement-link">
            Нажимая кнопку «Оплатить», вы соглашаетесь с
            <a @click.prevent="showUserAgreement" href="#" target="_blank"
              >пользовательским соглашением</a
            >
            и
            <a @click.prevent="showPrivacyPolicy" href="#" target="_blank"
              >политикой конфиденциальности</a
            >.
          </div> -->
        </div>
      </div>
    </div>
    <ModalCard />
    <Registration />
    <UserAgreement />
    <PrivacyPolicy />
    <WarningModal
      v-bind:icon="warningImage"
      v-bind:title="warningTitle"
      v-bind:text="warningText"
    />

    <WarningPushkinModal />
    <WarningModalBuy />
    <SbpPaymentCheckModal
      v-if="this.isSbpSelected"
      :url="this.paymentUrl"
      :paymentId="this.paymentId"
    />
    <SbpPaymentModal
      v-if="this.isSbpSelected"
      :url="this.paymentUrl"
      :paymentId="this.paymentId"
    />
    <WaitingForCardPaymentModal
      v-if="user.paymentType === 'Base'"
      :url="this.paymentUrl"
      :paymentId="this.paymentId"
    />
    <WaitingForPushkinCardPaymentModal
      v-if="user.paymentType === 'PushkinFilm'"
      :url="this.paymentUrl"
      :paymentId="this.paymentId"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { types } from '@/types';
import Timer from '@/components/Timer';
import ModalCard from '@/components/modals/ModalCard';
import Registration from '@/components/modals/Registration';
import UserAgreement from '@/components/modals/UserAgreement';
import PrivacyPolicy from '@/components/modals/PrivacyPolicy.vue';
import SbpPaymentModal from '@/components/modals/SbpPaymentModal.vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/material.css';
import AccountButton from '../../components/AccountButton';
import WarningModal from '@/components/modals/WarningModal';
import WarningPushkinModal from '@/components/modals/WarningPushkinModal.vue';
import { mask } from 'vue-the-mask';
import svg1 from '../../components/svg/Svg1';
import urlQueryParts from '../../helpers/urlQueryParts';
import WarningModalBuy from '@/components/modals/WarningModalBuy.vue';
import SbpPaymentCheckModal from '@/components/modals/SbpPaymentCheckModal.vue';
import WaitingForCardPaymentModal from '@/components/modals/WaitingForCardPaymentModal.vue';
import WaitingForPushkinCardPaymentModal from '@/components/modals/WaitingForPushkinCardPaymentModal.vue';
import { setting } from '@/setting';
import GiftCards from '@/components/GiftCards.vue';

export default {
  name: 'Buy',
  directives: { mask },

  updated() {
    if (
      (this.cart.bar.length || this.cart.donations) &&
      this.user.paymentType === 'PushkinFilm'
    ) {
      this.$modal.show('pushkin-modal');
    }

    this.isScroll =
      this.$refs.heightBody.clientHeight + 65 > window.innerHeight;
  },

  computed: {
    ...mapState([
      'cart',
      'bar',
      'session',
      'theatre',
      'movie',
      'user',
      'setting',
      'customer',
      'orderId',
      'promoData',
    ]),
    ...mapState({
      email: (state) => state.user.email,
      name: (state) => state.user.name,
      subscription: (state) => state.user.subscription,
      isAgreementsAccepted: (state) => state.user.isAgreementsAccepted,
      isVkWidget: (state) => state.isVkWidget,
      isVkMobileWidget: (state) => state.isVkMobileWidget,
    }),
    ...mapGetters(['total', 'notifications']),
    ...mapState(['giftCards']),
    amountDue() { return this.$store.getters['giftCards/due']; },
    showPaymentMethods() {
      return this.amountDue > 0 || Number(this.cart.usedBonuses) > 0 || !!this.isPushkinShow ||
        (this.giftCards.allowed && !this.giftCards.enabled);
    },
    paymentBusy() {
      return !this.paymentInitialized || this.giftCards.busy ||
        (this.giftCards.enabled && this.giftCards.allowed !== false && this.user.isAuthorized &&
          !this.isVkWidget && !this.isVkMobileWidget && this.user.paymentType !== 'PushkinFilm' && !this.giftCards.ready) ||
        !!this.$store.state.loading.createOrder || !!(this.$refs.giftCards && this.$refs.giftCards.binding);
    },
    submitBtnText() {
      if (this.movie.IsEventRegister) {
        return 'Зарегистрироваться';
      }

      return this.amountDue ? 'Перейти к оплате' : 'Получить';
    },
    isCardShow() {
      return this.setting.enabledPayments.find((i) => i === 'Card');
    },
    isPushkinShow() {
      return (
        this.session.PushkinId &&
        this.setting.enabledPayments.find((i) => i === 'PushkinCard')
      );
    },
    isSbpEnabled() {
      return this.setting.enabledPayments.find((i) => i === 'Sbp');
    },
    tooltipPushkinText() {
      return 'По пушкинской карте можно приобрести только 1 билет';
    },
    showDonationStep() {
      return !this.movie.IsEventRegister && this.theatre.Donation.IsActive &&
        (!this.session.Hall || !this.session.Hall.HallType || this.session.Hall.HallType.Name !== 'Мероприятия') &&
        this.user.paymentType !== 'PushkinFilm';
    },
    showPromoStep() {
      return !this.movie.IsEventRegister && this.user.isAuthorized && !this.promoData &&
        (!this.session.Hall || !this.session.Hall.HallType || this.session.Hall.HallType.Name !== 'Мероприятия') &&
        this.user.paymentType !== 'PushkinFilm';
    },
    giftCardsStep() {
      return 2 + Number(!!this.showDonationStep) + Number(!!this.showPromoStep);
    },
    paymentMethodLabel() {
      return (this.giftCardsStep + Number(!!this.$store.getters['giftCards/visible'])) + '. Способ оплаты';
    },
  },

  components: {
    GiftCards,
    AccountButton,
    ModalCard,
    Registration,
    UserAgreement,
    PrivacyPolicy,
    Timer,
    VueSlider,
    WarningModal,
    WarningPushkinModal,
    WarningModalBuy,
    SbpPaymentModal,
    SbpPaymentCheckModal,
    WaitingForCardPaymentModal,
    WaitingForPushkinCardPaymentModal,
    svg1,
  },

  async mounted() {
    if (!this.isSbpEnabled) {
      this.setPaymentType('Base');
    }

    await this.$store.dispatch('openBuyPage', {
      theatreId: this.$route.params.theatreId,
      session: this.$route.params.session,
      filmId: this.$route.query.filmId,
    });
    this.paymentInitialized = true;

    const notificationData = this.notifications(
      this.$route.name,
      (this.session.Format && this.session.Format.Name) || '',
    );

    const { Image, Title, Text } = notificationData || {};

    if (
      notificationData &&
      (this.warningImage != Image ||
        this.warningTitle != Title ||
        this.warningText != Text)
    ) {
      const host = process.env.VUE_APP_API_HOST_NEW_WIDGET;

      this.warningImage = `${
        typeof host === 'string' ? host.replace('api.', '') : ''
      }/${Image}`;
      this.warningTitle = Title;
      this.warningText = Text;
      this.$modal.show('warning-modal');
    }
  },

  data() {
    return {
      paymentInitialized: false,
      sbpLogo: require('../../assets/sbp.svg'),
      linkOnSiteWithWidget: setting.siteHost,
      emailError: false,
      isAgreementsAcceptedError: false,
      userNameError: false,
      bonusSliderShown: false,
      usedBonuses: 0,
      maxBonuses: 0,
      authFormShown: false,
      warningImage: '',
      warningTitle: '',
      warningText: '',
      promoError: null,
      isScroll: false,
      userAgreenment: false,
      userAgreenmentError: false,
      paymentId: '',
      paymentUrl: '',
      isSbpSelected: true,
      fullName: '',
      fullNameError: false,
      country: '',
      countryError: false,
      city: '',
      cityError: false,
      organization: '',
      organizationError: false,
      cinemaName: '',
      cinemaNameError: false,
      phoneError: false,
      isSubmitted: false,
    };
  },

  methods: {
    onManualBonuses() { this.$store.dispatch('giftCards/manualBonuses'); },

    goBack() {
      const theatreAndSessionPart = `${this.$route.params.theatreId}/${this.$route.params.session}`;

      if (this.$route.params.theatreId && !this.$route.params.session) {
        if (false) { //временное отключение бара
        // if (this.theatre.HasBar) {
          this.$router.push(
            `/${this.$route.params.theatreId}/bar${urlQueryParts(
              this.$route.query,
            )}`,
          );
        } else {
          this.$router.push(
            `/${this.$route.params.theatreId}/hall${urlQueryParts(
              this.$route.query,
            )}`,
          );
        }
        return;
      }

      if (false) { //временное отключение бара
      // if (this.bar.length && this.theatre.HasBar) {
        this.$router.push(
          `/${theatreAndSessionPart}/bar${urlQueryParts(this.$route.query)}`,
        );
      } else if (
        this.session &&
        this.session.Hall &&
        this.session.Hall.HallType &&
        this.session.Hall.HallType.Name === 'Мероприятия'
      ) {
        this.$router.push(
          `/${theatreAndSessionPart}/support-cultural-program${urlQueryParts(
            this.$route.query,
          )}`,
        );
      } else {
        this.$router.push(
          `/${theatreAndSessionPart}/hall${urlQueryParts(this.$route.query)}`,
        );
      }
    },
    log: (m) => console.log(m),

    onlyNumber(e) {
      let keyCode = e.keyCode ? e.keyCode : e.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        e.preventDefault();
      }
    },
    onChangeInputDonationSizes(e) {
      if (e.target.value >= 0) {
        this.$store.commit(types.SET_DONATION_SIZE, e.target.value);
      }
    },

    onChangeInputPromocode(e) {
      this.$store.commit(
        types.SET_PROMOCODE_VALUE,
        e.target.value.toUpperCase(),
      );

      this.promoError = null;
    },

    usePromocodeClick(e) {
      e.preventDefault();
      this.$store
        .dispatch('usePromocode', {
          Promocode: this.cart.promocode,
          Email: this.email,
        })
        .then(() => {
          this.promoError = this.cart.promoError;
          if (!this.cart.promocode) {
            setTimeout(() => {
              this.promoError = null;
            }, 3000);
          }
        });
    },

    selectDonationSizes(donationSize) {
      this.$store.commit(types.SET_DONATION_SIZE, donationSize);
    },

    updateEmail(e) {
      this.updateProperty('user', 'email', e.target.value);
      this.validateEmail();
    },

    updateFullName(e) {
      this.fullName = e.target.value;
      this.updateNameForEventRegistration();
      this.validateFullName();
    },

    validateFullName() {
      if (!this.fullName) {
        this.fullNameError = 'Поле обязательно для заполнения';
        return false;
      }

      this.fullNameError = false;
      return true;
    },

    updateCountry(e) {
      this.country = e.target.value;
      this.updateNameForEventRegistration();
      this.validateCountry();
    },

    validateCountry() {
      if (!this.country) {
        this.countryError = 'Поле обязательно для заполнения';
        return false;
      }

      this.countryError = false;
      return true;
    },

    updateCity(e) {
      this.city = e.target.value;
      this.updateNameForEventRegistration();
      this.validateCity();
    },

    validateCity() {
      if (!this.city) {
        this.cityError = 'Поле обязательно для заполнения';
        return false;
      }

      this.cityError = false;
      return true;
    },

    updateOrganization(e) {
      this.organization = e.target.value;
      this.updateNameForEventRegistration();
      this.validateOrganization();
    },

    validateOrganization() {
      if (!this.organization) {
        this.organizationError = 'Поле обязательно для заполнения';
        return false;
      }

      this.organizationError = false;
      return true;
    },

    updateCinemaName(e) {
      this.cinemaName = e.target.value;
      this.updateNameForEventRegistration();
      this.validateCinemaName();
    },

    validateCinemaName() {
      this.organizationError = false;
      return true;
    },

    validateEmail() {
      if (!this.isSubmitted) {
        return true;
      }

      if (!this.user.email) {
        this.emailError = 'Необходимо заполнить email';
        return false;
      }

      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.user.email)) {
        this.emailError = 'Некорректный ввод email';
        return false;
      }

      this.emailError = false;
      return true;
    },

    updateNameForEventRegistration() {
      const name = [
        this.fullName,
        this.country,
        this.city,
        this.organization,
        this.cinemaName,
      ]
        .filter(Boolean)
        .join(', ');
      this.updateProperty('user', 'name', name);
    },

    updateUserPhone(e) {
      this.updateProperty('user', 'phone', e.target.value);
      this.validatePhone();
    },

    validatePhone() {
      if (!this.isSubmitted) {
        return true;
      }

      if (!this.user.phone) {
        this.phoneError = 'Поле обязательно для заполнения';
        return false;
      }

      if (this.user.phone.length && this.user.phone.length < 18) {
        this.phoneError = 'Номер телефона введен некорректно';
        return false;
      }

      this.phoneError = false;

      return true;
    },

    updateUserName(e) {
      this.updateProperty('user', 'name', e.target.value);
      this.validateUserName();
    },

    validateUserName() {
      if (!this.user.name) {
        this.userNameError = 'Необходимо заполнить имя';

        return false;
      }

      this.userNameError = false;
      return true;
    },

    updateSubscription(e) {
      this.updateProperty('user', 'subscription', e.target.checked);
    },

    updateAgreementsAccepted(e) {
      this.updateProperty('user', 'isAgreementsAccepted', e.target.checked);
      this.validateAgreementsAccepted();
    },

    validateAgreementsAccepted() {
      if (!this.user.isAgreementsAccepted) {
        this.isAgreementsAcceptedError = 'Необходимо принять соглашение';
        return false;
      }

      this.isAgreementsAcceptedError = false;
      return true;
    },

    updateUserAgreenment(e) {
      if (this.userAgreenment && !e.target.checked) {
        this.userAgreenmentError = true;
      } else {
        this.userAgreenmentError = false;
      }

      this.userAgreenment = e.target.checked;
    },

    validateUserAgreenment() {
      if (!this.userAgreenment) {
        this.userAgreenmentError = true;
        return false;
      }

      return true;
    },

    updateProperty(stateObject, stateObjectProp, value) {
      //debugger
      this.$store.commit(types.UPDATE_PROP_VALUE, {
        stateObject: stateObject,
        stateObjectProp: stateObjectProp,
        value: value,
      });
    },

    getTotalPrice(price, count) {
      return price * count;
    },

    showUserAgreement() {
      this.$modal.show('user-agreement');
    },

    showPrivacyPolicy() {
      this.$modal.show('privacy-policy');
    },

    showSbpModal() {
      this.$modal.show('sbp-payment');
    },

    showWaitingForCardPaymentModal() {
      this.$modal.show('card-payment');
    },

    showWaitingForPushkinCardPaymentModal() {
      this.$modal.show('pushkin-card-payment');
    },

    showSbpCheckModal() {
      this.$modal.show('sbp-payment-check');
    },

    updateSbpIsSelected() {
      this.isSbpSelected = true;
      this.user.paymentType = 'Base';
    },

    setPaymentType(paymentType) {
      if (paymentType === 'PushkinFilm') {
        if (this.cart.tickets.length !== 1) {
          return false;
        }

        this.$store.commit(types.UNSELECT_CUSTOMER_ACCOUNTS);
        this.$store.commit(types.UNPICKED_CUSTOMER_ACCOUNTS);
        this.$store.commit(types.CALCULATE_CART);
      }

      this.user.paymentType = paymentType;
      this.isSbpSelected = false;
    },

    setPaymentWithBonuses(force = false, bonuses = 0) {
      this.$store.commit(types.CHANGE_PAYMENT_WITH_BONUSES, { force, bonuses });
      this.onManualBonuses();
    },

    isSelectedPayment(paymentType) {
      if (this.isSbpSelected) return false;

      return this.user.paymentType === paymentType;
    },

    openPaymentUrlInPlace(url) {
      window.location.href = url;
    },

    openPaymentUrlInNewTab(url) {
      // window.open(url, '_blank');
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.click();
    },

    makeOrder: async function () {
      if (this.paymentBusy) return;
      this.isSubmitted = true;

      const callSbpDialog = (formUrl) => {
        if (!formUrl) return;

        if (this.$isMobile()) {
          this.showSbpCheckModal();
        } else {
          this.showSbpModal();
        }
      };

      if (
        typeof window.ym != 'undefined' &&
        window.location.hostname !== 'localhost'
      ) {
        // eslint-disable-next-line no-undef
        ym(52995523, 'reachGoal', 'buy');
      }

      if (this.validateAgreementsAccepted()) {
        if (this.user.paymentType === 'PushkinFilm') {
          if (
            this.validatePhone() &&
            this.validateEmail() &&
            this.validateUserName() &&
            this.validateUserAgreenment()
          ) {
            this.$store
              .dispatch('createOrder', {
                theatreId: this.$route.params.theatreId,
                theatreSessionId: this.$route.params.session,
                roistatVisit: this.$route.query.roistatVisit,
              })
              .then(async (res) => {
                if (!res || res.completed) return;
                if (res.success === false) {
                  if (this.giftCards.allowed && this.$refs.giftCards) await this.$refs.giftCards.load(true);
                  return;
                }
                if (!res.formUrl) {
                  console.error('Error in createOrder', res);
                  return;
                }

                this.paymentUrl = res.formUrl;
                this.paymentId = res.paymentId;

                this.openPaymentUrlInNewTab(res.formUrl);
                this.showWaitingForPushkinCardPaymentModal();
              });
          }
        } else if (this.movie.IsEventRegister) {
          if (
            this.validateEmail() &&
            this.validatePhone() &&
            this.validateFullName() &&
            this.validateCountry() &&
            this.validateCity() &&
            this.validateOrganization() &&
            this.validateCinemaName()
          ) {
            this.$store
              .dispatch('createOrder', {
                theatreId: this.$route.params.theatreId,
                theatreSessionId: this.$route.params.session,
                roistatVisit: this.$route.query.roistatVisit,
                isSbpSelected: this.isSbpSelected,
              })
              .then(async (res) => {
                if (!res || res.completed) return;
                if (res.success === false) {
                  if (this.giftCards.allowed && this.$refs.giftCards) await this.$refs.giftCards.load(true);
                  return;
                }
                if (!res.formUrl || !res.paymentId) {
                  console.error('Error in createOrder', res);
                  return;
                }

                this.paymentUrl = res.formUrl;
                this.paymentId = res.paymentId;
                if (this.isSbpSelected) {
                  callSbpDialog(res.formUrl);
                } else {
                  this.openPaymentUrlInNewTab(res.formUrl);
                  this.showWaitingForCardPaymentModal();
                }
              });
          }
        } else {
          if (this.validateEmail() && this.validatePhone()) {
            this.$store
              .dispatch('createOrder', {
                theatreId: this.$route.params.theatreId,
                theatreSessionId: this.$route.params.session,
                roistatVisit: this.$route.query.roistatVisit,
                isSbpSelected: this.isSbpSelected,
              })
              .then(async (res) => {
                if (!res || res.completed) return;
                if (res.success === false) {
                  if (this.giftCards.allowed && this.$refs.giftCards) await this.$refs.giftCards.load(true);
                  return;
                }
                if (!res.formUrl || !res.paymentId) {
                  console.error('Error in createOrder', res);
                  return;
                }

                this.paymentUrl = res.formUrl;
                this.paymentId = res.paymentId;
                if (this.isSbpSelected) {
                  callSbpDialog(res.formUrl);
                } else {
                  this.openPaymentUrlInNewTab(res.formUrl);
                  this.showWaitingForCardPaymentModal();
                }
              });
          }
        }
      }
    },

    getLeftBonuses() {
      return (
        this.user.card.balance -
        (this.cart.spentBonuses.bar + this.cart.spentBonuses.tickets)
      );
    },

    toggleBonusSlider() {
      this.bonusSliderShown = !this.bonusSliderShown;
    },

    applyBonuses() {
      this.setPaymentWithBonuses(true, this.cart.usedBonuses);
      this.toggleBonusSlider();
    },

    showModalCard() {
      this.$modal.show('modal-card');
    },

    showModalCardRegister() {
      this.$modal.show('registration-form');
    },
  },
};
</script>

<style src="./Buy.scss" lang="scss"></style>
